import React from "react";
export var HighlightText = function (_a) {
  var searchWords = _a.searchWords,
    textToHighlight = _a.textToHighlight,
    _b = _a.highlightClassName,
    highlightClassName = _b === void 0 ? "highlight" : _b;
  if (!searchWords.length || !textToHighlight) return React.createElement(React.Fragment, null, textToHighlight);
  var regex = new RegExp("(".concat(searchWords.map(function (word) {
    return word.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }).join("|"), ")"), "gi");
  var parts = textToHighlight.split(regex);
  return React.createElement(React.Fragment, null, parts.map(function (part, index) {
    return part && searchWords.some(function (word) {
      return word.toLowerCase() === part.toLowerCase().trim();
    }) ? React.createElement("span", {
      key: index,
      className: highlightClassName
    }, part) : part;
  }));
};
export default HighlightText;